import React from 'react'
import About from './About';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
export default function OurStory() {
    return (
        <About>
            <Box overflow={'hidden'}>
                <Box paddingLeft={'10%'} width={'65%'}>
                    <Grid container spacing={3}>
                        <Grid size={12}>
                            <Typography component={'h1'} fontWeight={'bold'} fontSize={'1.5rem'} className='dColor'>
                                Our Story
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
                <Box sx={{ marginY: '80px', width: 1, border: 'solid 1px #DBDAD9' }} />
                <Box paddingLeft={'10%'} width={{md: '65%', xs: '90%'}}>
                    <Grid container spacing={5}>
                        <Grid size={12}>
                            <Typography component={'p'} fontSize={'1.125rem'} className='dColor'>
                                RINU u krijua me një vizion të qartë: të bashkojë mjekësinë estetike të avancuar, teknologjinë inovative dhe kujdesin e personalizuar në një destinacion të vetëm.
                                <br /><br />
                                Qasja jonë shkon përtej trajtimeve tradicionale të bukurisë. Ne fokusohemi në trajtimin e lëkurës, trupit dhe mendjes së bashku, duke përdorur teknologji dhe trajtime të përzgjedhura me kujdes për të arritur rezultate natyrale dhe afatgjata.
                                <br /><br />
                                Çdo përvojë në RINU fillon duke kuptuar individin. Duke kombinuar ekspertizën, precizionin dhe një qasje holistike, ne krijojmë trajtime të përshtatura për nevojat e secilit klient.
                                <br />
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </About>
    )
}
